import React from 'react';
import PropTypes from 'prop-types';
import SubSection from '../components/SubSection';
import ControlledFormInput from '../components/ControlledFormInput';

const ContactInfo = ({
  description = null,
  title,
  name,
  email,
  company,
  jobTitle,
  onChange,
  onBlur,
}) => {
  return (
    <SubSection
      title={title}
      description={description}
      variant="contact-info"
    >
      <ControlledFormInput
        field={name}
        onChange={onChange}
        onBlur={onBlur}
        required
      />
      <ControlledFormInput
        field={email}
        onChange={onChange}
        onBlur={onBlur}
        required
      />
      <ControlledFormInput
        field={company}
        onChange={onChange}
        onBlur={onBlur}
        required
      />
      <ControlledFormInput
        field={jobTitle}
        onChange={onChange}
        onBlur={onBlur}
      />
    </SubSection>
  );
};

ContactInfo.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  name: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  email: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  company: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  jobTitle: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
};

export default ContactInfo;
